<template>
    <div class="d-flex flex-wrap flex-stack my-5">
        <router-link to="/module/etep" class="btn btn-primary align-self-center">
            <span class="svg-icon svg-icon-2">
                <inline-svg src="/media/icons/duotune/arrows/arr021.svg"/>
            </span>
            {{ $t("pages.module.eTep.title") }}
        </router-link>

        <router-link to="/module/etep/question/category" class="btn btn-primary align-self-center ms-3">
            {{ $t("pages.module.eTep.question.category.title") }}
            <span class="svg-icon svg-icon-2">
                <inline-svg src="/media/icons/duotune/arrows/arr024.svg"/>
            </span>
        </router-link>
    </div>

    <custom-table
        :title="$t('pages.module.eTep.question.title')"
        :subTitle="$t('pages.module.eTep.question.subTitle')"
        selectableRows
        rowKey="id"
        :items="table.data"
        :loading="table.loading"
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        filterComponentName="ModuleEtepQuestionFilter"
        @action="handleClickAction"
        @selectableRows="handleSelectedRow"
        @changeTable="handleTableChange">
        <template v-slot:title="{ row: record }">
            <div class="fw-bold fs-6">{{ record.alias ?? '-' }}</div>
            <div class="fw-normal fs-7">{{ $t('pages.module.eTep.questionType.' + resolveDatum(questionTypes, record.question_type_id, 'id').code) }}</div>
        </template>
        <template v-slot:section="{ row: record }">
            {{ resolveParent(treeSections, record.question_type_id, 'id').name }}
        </template>
        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <el-tooltip :content="$t('pages.module.eTep.question.answer.title')" placement="top" v-if="record.answers && record.answers.length">
                    <a class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer" v-on:click="showDetail('answerModal', record)">
                        <span class="svg-icon svg-icon-3">
                            <inline-svg src="/media/icons/duotune/text/txt009.svg"/>
                        </span>
                    </a>
                </el-tooltip>
                <router-link :to="'/module/etep/question/save/' + record.id" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                     <span class="svg-icon svg-icon-3">
                         <inline-svg src="/media/icons/duotune/art/art005.svg"/>
                     </span>
                </router-link>
                <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="deleteRecord([record.id])">
                    <template #reference>
                        <a class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                            <span class="svg-icon svg-icon-3">
                                <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                            </span>
                        </a>
                    </template>
                </el-popconfirm>
            </div>
        </template>
    </custom-table>

</template>

<script>
import CustomTable from "@/components/custom-table";

export default {
    name: "index",
    components: {
        CustomTable
    },
    data() {
        return {
            fields: [
                {
                    name: this.$t("common.id"),
                    key: "id",
                    class: ""
                },
                {
                    name: this.$t("pages.module.eTep.question.cols.title") + ' / ' + this.$t("pages.module.eTep.question.cols.type"),
                    scopedSlots: {customRender: "title"}
                },
                {
                    name: this.$t("pages.module.eTep.question.cols.sectionType"),
                    scopedSlots: {customRender: "section"}
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            actions: [
                {
                    name: "new",
                    icon: "bi-plus-lg",
                    label: "btn.add"
                },
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                },
                {
                    name: "delete",
                    icon: "bi-trash",
                    label: "btn.delete"
                }
            ],
            selectedRowKeys: [],
            showDetailData: null,
            treeSections: []
        }
    },
    computed: {
        table() {
            return this.$store.state.module.etep.question.table;
        },
        questionTypes() {
            return this.$store.state.module.etep.question.type.table.data;
        },
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("pages.module.eTep.question.title"), [this.$t("menu.moduleManagement"), this.$t("pages.module.eTep.title")]);

        this.$store.dispatch('module/etep/question/get', {
            page: {},
            filterData: Object.assign(this.$root.getFilterWithUrl({}), {
                include_answers: 1
            })
        });
        this.$store.dispatch('module/etep/question/type/get', {
            page: {pageSize: 9999}
        });

        this.loadTreeSections();
    },
    methods: {
        loadTreeSections() {
            this.axios.get(this.endpoints['module_etep_section_type']).then((response) => {
                this.treeSections = response.data.data;
                response.data.data.forEach((value, index) => {
                    this.axios.get(this.endpoints['module_etep_question_type'] + '?section_id=' + value.id).then((res) => {
                        this.treeSections[index].children = res.data.data
                    });
                })
            });
        },
        deleteRecord(id) {
            this.$store.dispatch("module/etep/question/delete", {
                id: id
            }).then((successDeleted) => {
                this.selectedRowKeys = this.selectedRowKeys.filter(x => !successDeleted.includes(x));
            });
        },
        handleClickAction(name) {
            switch (name) {
                case "refresh":
                    this.refreshTable();
                    break;

                case "new":
                    this.$router.push({
                        path: "/module/etep/question/save"
                    });
                    break;

                case "delete":
                    this.deleteRecord(this.selectedRowKeys.flat());
                    break;

                default:
                    break;
            }
        },
        refreshTable() {
            this.$store.dispatch("module/etep/question/refresh");
        },
        handleTableChange(pagination, filterData) {
            this.$store.dispatch("module/etep/question/get", {
                page: pagination,
                filterData: Object.assign({
                    include_answers: 1
                }, filterData)
            });
        },
        handleSelectedRow(record) {
            this.selectedRowKeys = record;
        },
        getCorrectAnswer(record) {
            let result = null;

            if (record.answers && record.answers.length && record.correct_answer_id) {
                record.answers.sort((a, b) => {
                    return a.sort - b.sort;
                });

                let foundIndex = record.answers.findIndex((answer) => answer.id == record.correct_answer_id);

                if (foundIndex != -1) {
                    result = {
                        foundIndex: foundIndex,
                        record: record.answers[foundIndex],
                    }
                }
            }

            return result;
        },
        showDetail(modalName, record) {
            this.showDetailData = record;

            if (modalName == 'correctAnswerModal') {
                this.showDetailData = this.getCorrectAnswer(record);
            }

            let modal = this.$refs[modalName];
            if (modal && this.showDetailData) {
                this.showModal(modal);
            }
        },
        getRecord(type, record) {
            if (this.questionTypes.length) {
                let recordTypeCode = this.resolveDatum(this.questionTypes, record.question_type_id, 'id').code;
                let splitted = recordTypeCode.split('_').map((part) => this.ucFirst(part));
                let methodName = 'getRecord' + splitted.join('');

                return this[methodName] ? this[methodName](type, record) : false
            }
        },
        getRecordNormal(type, record) {
            let typeData = {
                answerCount: record.answers_count
            }

            return typeData[type] ?? null;
        },
        getRecordImage(type, record) {
            let typeData = {
                answerCount: record.external_answer_count,
                correctAnswer: this.sprintf(
                    this.$t('pages.module.eTep.question.answer.titlePattern'),
                    [this.$root.questionLetters[(record.correct_answer_id - 1)]]
                )
            }

            return typeData[type] ?? null;
        },
        getRecordTrueOrFalse(type, record) {
            let typeData = {
                answerCount: 2,
                correctAnswer: this.$t('common.' + (record.correct_answer_id == 1 ? 'true' : 'false'))
            }

            return typeData[type] ?? null;
        }
    }
}
</script>

<style>
.table p {
    margin-bottom: 0;
}

.table img, .modal .detail-item img {
    width: 180px !important;
    height: 90px !important;
    object-fit: cover !important;
}
</style>